/**
 * Keeps browser number inputs bounded by their real domain instead of treating
 * a fractional spinner increment as an additional validity constraint.
 */
export function normalizeNumericInputValidation(root: ParentNode): void {
  const normalizeInput = (input: HTMLInputElement): void => {
    const step = input.getAttribute("step");
    if (step === null || step === "any") {
      return;
    }
    const numericStep = Number(step);
    if (Number.isFinite(numericStep) && numericStep > 0 && !Number.isInteger(numericStep)) {
      input.step = "any";
    }
  };
  const normalize = (scope: ParentNode): void => {
    for (const input of scope.querySelectorAll<HTMLInputElement>('input[type="number"]')) {
      normalizeInput(input);
    }
  };

  normalize(root);
  if (typeof MutationObserver !== "undefined" && typeof Node !== "undefined" && root instanceof Node) {
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof HTMLInputElement && node.type === "number") {
            normalizeInput(node);
          }
          if (node instanceof HTMLElement) {
            normalize(node);
          }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }
}
